import { useCallback, useState } from 'react'

import { useAsyncFn, useEffectOnce } from '@clara/hooks'
import { useSidePanelContext } from '@clara/layout-next'

import { http } from '@/lib'

import { ReimbursementsResponse } from '../types/reimbursement'
import { MyReimbursementsEnum } from '../state/search/search-reducer'
import { getExistingReimbursementsWarningSidePanel } from '../components/bank-info/existing-reimbursements-warning'

async function getReimbursements(query: any) {
  return http
    .get<ReimbursementsResponse>('/', { params: query })
    .then((res) => res.data)
}

export function useReimbursementsInProgress<
  T extends (...args: any[]) => Promise<void>,
>(updateBankInfo: T) {
  const [
    AreThereReimbursementsInProgress,
    setAreThereReimbursementsInProgress,
  ] = useState(false)
  const sidePanel = useSidePanelContext()

  const [_, load] = useAsyncFn(async () => {
    const res = await getReimbursements({
      myReimbursements: MyReimbursementsEnum.MY_REIMBURSEMENTS,
      status: 'PENDING, APPROVED',
    })
    setAreThereReimbursementsInProgress(res.totalElements > 0)
  }, [])

  useEffectOnce(() => {
    load()
  })

  const onSubmit: <T>(data: T) => void = useCallback(
    async (data) => {
      if (AreThereReimbursementsInProgress) {
        sidePanel.onOpen(
          sidePanel.panels.concat(
            getExistingReimbursementsWarningSidePanel({
              onContinue: () => updateBankInfo(data),
            }),
          ),
          sidePanel.index + 1,
        )
      } else {
        updateBankInfo(data)
      }
    },
    [AreThereReimbursementsInProgress, sidePanel, updateBankInfo],
  )

  return { onSubmit }
}
